module.exports = __webpack_public_path__ + "6adf50fa12eef82b533eaa636bf04ec1.png";